export default __webpack_public_path__ + "media/images/icons/inverse-x-37c236dd89fe36f0d0076fe10683825f.svg";